export const ACCESS_TOKEN = 'hospital-access-token';
export const USER_DETAILS = 'hospital-user-details';
